const bookingTracking = (form, data) => {
    try {
        if (window.GalaxyEventTracking) {
            /* EVENT TRACKING */
            window.GalaxyEventTracking.events.bookingMaskSubmit({
                buttonText: $(form).find(':submit').text().trim() || $(form).find(':submit').val().trim(),
                position: GalaxyEventTracking.calculateElementPosition($(form).find(':submit')),
            });

            window.GalaxyEventTracking.events.bookingIntention({
                rooms: data.rooms,
                adults: data.adults,
                children: data.children,
                code: data.promoCode,
                dateIn: data.datein,
                dateOut: data.dateout,
            });
        }
    } catch (error) {
        console.error(error);
    }
}

function addEvents() {
    const GalaxyBookingMask = window.GalaxyBookingMask;

    var $bookingForm = $('.js-booking-form'),
        idBE = $bookingForm.data('bookingEngine');

    $bookingForm.on('submit', function (e) {
        e.preventDefault();

        var arrayData = $(this).serializeArray();
        var data = {}
        arrayData.forEach(function (el) {
            data[el.name] = el.value
        });

        data.locale = $('html').attr('lang');

        var URL = GalaxyBookingMask.buildUrl({
            BE: idBE,
            url: $(this).attr('action'),
            data: data
        });

        bookingTracking(this, data);

        window.open(URL, '_blank');

    });

}

function initBookingMask() {
    $.getScript(window.glxGenericBmUrl).then(() => {
        addEvents();
    }).catch(() => {
        console.error('Error loading glxGenericBmUrl for booking mask');
    });
}

export default initBookingMask;
